import greenGele from "../../assets/gele15.png";
import React, { useEffect } from "react";
import largeCircle from "../../assets/code-circle-l.svg";
import mediumCircle from "../../assets/code-circle-m.svg";
import smallCircle from "../../assets/code-circle-s.svg";

import "aos/dist/aos.css";
import Aos from "aos";
function Presentations(props) {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  });
  return (
    <div className="flex flex-col lg:flex-row lg:justify-between bg-[#01030d] w-full z-10 p-10 md:px-[130px] md:py-[200px]">
      <div data-aos="flip-right" className="z-10 mt-5">
        <h1 className="text-[#d02561] text-2xl md:text-5xl ">
          8,888 unique Geles
        </h1>
        <span className="text-white text-2xl md:text-5xl ">
          {" "}
          who need Drivers.
        </span>

        <p data-aos="flip-left" className="mt-5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        <p className="mt-5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      </div>

      <div
        data-aos-anchor-placement="top-center"
        className="z-10 md:mt-[-110px] w-full "
      >
        {/* <img className="w-full md:mt-[120px] lg:mt-0" src={greenGele} alt="" /> */}
        <div
          style={{ overflow: "hidden" }}
          id="circleWithAvatar"
          className="relative flex justify-center circleWithAvatar h-full "
        >
          <img className="absolute spinnerForward" src={smallCircle} alt="" />
          <img className="absolute spinnerReverse" src={mediumCircle} alt="" />
          <img className="absolute spinnerForward" src={largeCircle} alt="" />
          {/* <img className="absolute" src="headline" alt="" /> */}
          <img
            className="w-2/3 md:mt-[120px] lg:mt-10 mt-[50px]"
            src={greenGele}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default Presentations;
